var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLvl1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#000000",
    id: "svg48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none",
    id: "path44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z",
    id: "path46"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ff00",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,18 V 17.005988 H 12 20.994012 V 18 18.994012 H 12 3.005988 Z",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,14 V 13.005988 H 12 20.994012 V 14 14.994012 H 12 3.005988 Z",
    id: "path345"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,14 V 13.005988 H 12 20.994012 V 14 14.994012 H 12 3.005988 Z",
    id: "path416"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,10 V 9.005988 H 12 20.994012 V 10 10.994012 H 12 3.005988 Z",
    id: "path418"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,6 V 5.005988 H 12 20.994012 V 6 6.994012 H 12 3.005988 Z",
    id: "path420"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,14 V 13.005988 H 12 20.994012 V 14 14.994012 H 12 3.005988 Z",
    id: "path491"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,10 V 9.005988 H 12 20.994012 V 10 10.994012 H 12 3.005988 Z",
    id: "path493"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,6 V 5.005988 H 12 20.994012 V 6 6.994012 H 12 3.005988 Z",
    id: "path495"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080",
      strokeWidth: 0.0239521
    },
    d: "M 3.005988,6 V 5.005988 H 12 20.994012 V 6 6.994012 H 12 3.005988 Z",
    id: "path497"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl1);
export default __webpack_public_path__ + "static/media/lvl-1.88b9990f8c27cfc8aca269f29deed67f.svg";
export { ForwardRef as ReactComponent };